<script setup lang="ts">
import { UiHubCard } from '@ui'
import { useLandingPages } from '~/composables/content/landing'

const { t } = useI18n()
const {
  public: { siteUrl },
} = useRuntimeConfig()

const { data: landingPages } = await useLandingPages()

const landings = computed(() => landingPages.value)

useSeoMeta({
  title: t('belongs-mobile-app-for'),
  description: t('download-and-install-belong-application'),
  ogTitle: t('belongs-mobile-app-for'),
  ogDescription: t('download-and-install-belong-application'),
  ogImage: `${siteUrl}/images/head/snippet_screen.png`,
  ogImageWidth: '1200',
  ogImageHeight: '630',
  ogImageType: 'image/png',
  ogType: 'website',
  twitterTitle: t('belongs-mobile-app-for'),
  twitterDescription: t('download-and-install-belong-application'),
  twitterImage: `${siteUrl}/images/head/snippet_screen.png`,
  twitterCard: 'summary_large_image',
})

definePageMeta({
  layout: 'base',
})

const stripHtmlTags = (text: string) => {
  return text.replace(/<[^>]*>?/gm, '')
}
</script>

<template>
  <div v-if="landings?.length" class="container mx-auto container-grid">
    <template v-for="landing in landings" :key="landing.documentId">
      <NuxtLinkLocale
        :to="`/demos/${landing.slug}`"
        class="cursor-pointer block w-full"
      >
        <UiHubCard
          class="flex w-full"
          :image="
            landing.backgroundImage?.url ? landing.backgroundImage.url : ''
          "
          :coverImageDominantColors="[]"
        >
          <template #title> {{ landing.title }} </template>

          <div class="flex-1 py-4">
            <p class="line-clamp-2 text-white/80 text-sm">
              {{ stripHtmlTags(landing.description) }}
            </p>
          </div>
        </UiHubCard>
      </NuxtLinkLocale>
    </template>
  </div>
</template>

<style scoped>
@reference "tailwindcss";
.container-grid {
  @apply grid grid-flow-row gap-8 px-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4;
}
</style>
